/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'

import { useBackgroundStyle } from '../../utils/styles/background'

const Sticky = ({ zIndex, ...props }) => {
  const style = css`
    position: sticky;
    top: 0;
    z-index: ${zIndex || 0};
    ${useBackgroundStyle(props)}
  `

  return <div css={style} {...props} />
}

export default Sticky
